/* eslint-disable unicorn/consistent-function-scoping */
import { Component, computed, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { RouterModule } from '@angular/router';
import { SiteSetupComponentService } from '../../site-setup.component.service';

export enum StepState {
  Active = 'active',
  Completed = 'completed',
  CurrentInContract = 'currentInContract',
  Disabled = 'disabled',
}

@Component({
  selector: 'lib-navigation-step',
  imports: [CommonModule, SvgIconComponent, RouterModule],
  templateUrl: './navigation-step.component.html',
  styleUrl: './navigation-step.component.scss',
})
export class NavigationStepComponent {
  private readonly siteSetupComponentService = inject(SiteSetupComponentService);

  @Input() public stepNumber: number = 0;
  @Input() public title: string = '';
  @Input() public route: string = '';

  public StepState = StepState;

  public numberToDisplay = computed(() => this.siteSetupComponentService.getStepNumberToDisplay(this.stepNumber));
  public state = computed(() => this.siteSetupComponentService.getStepState(this.stepNumber));

  public onStepClick(stepNumber: number): void {
    this.siteSetupComponentService.setActiveStep(stepNumber);
  }
}
